module.exports = __webpack_public_path__ + "static/img/image041.37d46ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image041.png
// module id = 9Xxd
// module chunks = 1